import { Pipe, PipeTransform } from '@angular/core';
import mapToNumeric from '../helpers/mapToNumeric';

@Pipe({ name: 'maskCpf' })
export class MaskCpfPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		// let cpf: string = value;
		// if (cpf) {
		// 	cpf = cpf.replace(/\D/g, '');
		// 	if (cpf.length > 3 && cpf.length <= 6) {
		// 		return `${cpf.substr(0, 3)}.${cpf.substr(3, cpf.length - 1)}`;
		// 	} else if (cpf.length > 6 && cpf.length <= 9) {
		// 		return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, cpf.length - 1)}`;
		// 	} else if (cpf.length > 9 && cpf.length <= 11) {
		// 		return `${cpf.substr(0, 3)}.${cpf.substr(3, 3)}.${cpf.substr(6, 3)}-${cpf.substr(9, cpf.length - 1)}`;
		// 	} else if (cpf.length > 11 && cpf.length <= 12) {
		// 		return `${cpf.substr(0, 2)}.${cpf.substr(2, 3)}.${cpf.substr(5, 3)}/${cpf.substr(8, cpf.length - 1)}`;
		// 	} else if (cpf.length > 12 && cpf.length <= 14) {
		// 		return `${cpf.substr(0, 2)}.${cpf.substr(2, 3)}.${cpf.substr(5, 3)}/${cpf.substr(8, 4)}-${cpf.substr(12, cpf.length - 1)}`;
		// 	}
		// }

		// return cpf;
		return (value || '').length > 0 ? mapToNumeric(value)
			.replace(/(\d{3})(\d)/, '$1.$2')
			.replace(/(\d{3})(\d)/, '$1.$2')
			.replace(/(\d{3})(\d{1,2})$/, '$1-$2') : '';
	}

}
@Pipe({ name: 'maskCnpj' })
export class MaskCnpjPipe implements PipeTransform {

	transform(value: any): any {
		return (value || '').length > 0 ? mapToNumeric(value)
			.replace(/(\d{2})(\d)/, '$1.$2')
			.replace(/(\d{3})(\d)/, '$1.$2')
			.replace(/(\d{3})(\d)/, '$1/$2')
			.replace(/(\d{4})(\d{1,2})$/, '$1-$2') : '';
	}

}
